module.exports = __webpack_public_path__ + "img/icon.f27dd144.png";